export default __webpack_public_path__ + "static/media/4-2_image24@2x.1efbb445.png";